// extracted by mini-css-extract-plugin
module.exports = {"main":"EventsTitle_main__HQ1jV"};